const CJK_PATTERN = /[\u4e00-\u9fff]/;

/** Prefer English copy when the backend returns a non-English message. */
export function userFacingError(error: unknown, fallback: string): string {
  const msg = error instanceof Error ? error.message.trim() : '';
  if (!msg || CJK_PATTERN.test(msg)) return fallback;
  return msg;
}
